import ShopaholicSearch from '@lovata/shopaholic-search';

export default new class listComponent {
  constructor() {
    this.sSearchInput = '_faq-search-input';
    this.searchResultWrapper = '_faq-search-result';

    this.searchIconClass = '_faq-search-icon';
    this.searchIconClassHidden = '_faq-search-icon__hidden';
    this.drawerBtnClose = '_faq-search-close__button';
    this.drawerBtnCloseActive = '_faq-search-close__button__active';

    this.init();
  }

  init() {
    this.initSearch();
    this.initSearchClose();
  }

  initSearch() {
    const obHelper = new ShopaholicSearch();
    $(document)
      .on('input', `.${this.sSearchInput}`, (obEvent) => {
        this.sSearchString = $(obEvent.currentTarget)
          .val();
        obHelper.processSearchString(this.sSearchString);
      });
    obHelper.setSearchDelay(600)
      .setAjaxRequestCallback((obRequestData) => {
        /* eslint-disable  no-param-reassign */
        obRequestData.update = { 'content/faq/faq-search/faq-search-result': `.${this.searchResultWrapper}` };
        obRequestData.complete = () => {
          $(`.${this.drawerBtnClose}`).toggleClass(this.drawerBtnCloseActive);
          $(`.${this.searchIconClass}`).toggleClass(this.searchIconClassHidden);
        };
        /* eslint-enable */
        return obRequestData;
      })
      .init();
  }

  initSearchClose() {
    $(document)
      .on('click', `.${this.drawerBtnClose}`, () => {
        $.request('onAjax', {
          complete: () => {
            $(`.${this.drawerBtnClose}`).toggleClass(this.drawerBtnCloseActive);
            $(`.${this.searchIconClass}`).toggleClass(this.searchIconClassHidden);
            $(`.${this.sSearchInput}`).val('');
            const searchResultWrapper = $(`.${this.searchResultWrapper}`);
            const childrenNode = searchResultWrapper.children();
            if (!childrenNode.length) return;
            childrenNode.remove();
          },
        });
      });
  }
}();
